interface HeatMeterProps {
  heat: number;
  className?: string;
}

export default function HeatMeter({ heat, className = "" }: HeatMeterProps) {
  const level = heat >= 90 ? "炸裂" : heat >= 80 ? "火热" : heat >= 70 ? "升温" : "常温";
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold text-accent-700 ${className}`}>
      <span className="w-4 h-4 flex items-center justify-center">
        <i className="ri-fire-fill text-accent-500" />
      </span>
      热度 {heat}
      <span className="text-foreground-400 font-normal">· {level}</span>
    </span>
  );
}